module.exports = __webpack_public_path__ + "img/md-globe.39717d8d.svg";